function makeTable(): number[] {
  return [
    ...Array.from({
      length: 256,
    }).fill(0),
  ].map((_, id) => {
    let c = id;
    Array.from({
      length: 8,
    })
      .fill(0)
      .forEach(() => {
        // eslint-disable-next-line no-bitwise
        c = c & 1 ? 0xed_b8_83_20 ^ (c >>> 1) : c >>> 1;
      });
    // eslint-disable-next-line no-bitwise
    return c >>> 0;
  });
}

function crcTable(arr: Uint8Array | undefined): number {
  // eslint-disable-next-line no-bitwise
  let crc = 0 ^ -1;

  if (!arr || arr.length === 0) {
    return crc;
  }

  const table = makeTable();

  arr.forEach((item) => {
    // eslint-disable-next-line no-bitwise
    crc = (crc >>> 8) ^ table[(crc ^ item) & 0xff];
  });

  // eslint-disable-next-line no-bitwise
  return crc ^ -1;
}

const encoder = new TextEncoder();

// Взято из: https://www.npmjs.com/package/crc32
// Экспортируется для тестирования
export function generateHash(str: string): string {
  const byteArray: Uint8Array = encoder.encode(str);
  const table: number = crcTable(byteArray);
  // eslint-disable-next-line no-bitwise
  return (table >>> 0).toString(16);
}

// На CI одновременно запускается много тестов, поэтому Date недостаточно, потребовался random
export function crc32(str: string): string {
  return generateHash(`${str}-${Date.now()}-${Math.floor(Math.random() * 1000)}`);
}
